import "../css/PaymentModal.css";

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";

export default function PaymentDetails({ sendPaymentMethodToParent }) {
  const navigate = useNavigate();

  const [showCC, setShowCC] = useState(false);
  const handleToggleCC = () => setShowCC(!showCC);

  const [showPP, setShowPP] = useState(false);
  const handleTogglePP = () => setShowPP(!showPP);

  const [showMP, setShowMP] = useState(false);
  const handleToggleMP = () => setShowMP(!showMP);

  const handlePaymentMethod = (ev) => {
    ev.preventDefault();
    const paymentMethods = {
      CC: "Visa",
      MP: "Mercado Pago",
      PP: "PayPal",
    };
    sendPaymentMethodToParent(paymentMethods[ev.target.id]);
    navigate("/checkout/3");
  };

  return (
    <div>
      <section className="mt-5 mb-5 d-inline-block">
        <h2>Step 2</h2>
        <h3>Select payment method</h3>

        <Button variant="" className="payment-method-selector" onClick={handleToggleCC}>
          <img
            src={process.env.REACT_APP_IMG_BASE_URL + "visa-mastercard.png"}
            width="80"
            alt="visa"
          />
        </Button>
        <Modal show={showCC} onHide={handleToggleCC} backdrop="static" keyboard={false}>
          <Modal.Body>
            <li className="nav-item" role="presentation">
              <a className="nav-link active">
                <img
                  src={process.env.REACT_APP_IMG_BASE_URL + "visa-mastercard.png"}
                  width="80"
                  alt="visa"
                />
              </a>
            </li>
            <form className="mt-4 mx-4" id="CC" onSubmit={handlePaymentMethod}>
              <div className="text-center">
                <h5>Credit card</h5>
              </div>
              <div className="form mt-3">
                <div className="inputbox">
                  <input type="text" name="name" className="form-control" required />
                  <span>Cardholder Name</span>
                </div>
                <div className="inputbox">
                  <input
                    type="text"
                    name="name"
                    min="1"
                    max="999"
                    className="form-control"
                    required
                  />
                  <span>Card Number</span>
                  <i className="fa fa-eye"></i>
                </div>
                <div className="d-flex flex-row">
                  <div className="inputbox">
                    <input
                      type="text"
                      name="name"
                      min="1"
                      max="999"
                      className="form-control"
                      required
                    />
                    <span>Expiration Date</span>
                  </div>
                  <div className="inputbox">
                    <input
                      type="text"
                      name="name"
                      min="1"
                      max="999"
                      className="form-control"
                      required
                    />
                    <span>CVV</span>
                  </div>
                </div>
                <div className="px-5 pay">
                  <button type="submit" className="btn btn-main btn-block confirm-button">
                    Add Credit Card
                  </button>
                </div>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleToggleCC}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Button variant="" className="payment-method-selector" onClick={handleTogglePP}>
          <img src={process.env.REACT_APP_IMG_BASE_URL + "paypal.png"} width="80" alt="PayPal" />
        </Button>
        <Modal show={showPP} onHide={handleTogglePP} backdrop="static" keyboard={false}>
          <ul className="nav nav-tabs" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <a className="nav-link">
                <img
                  src={process.env.REACT_APP_IMG_BASE_URL + "paypal.png"}
                  width="80"
                  alt="PayPal"
                />
              </a>
            </li>
          </ul>
          <Modal.Body>
            <form className="px-5 mt-5" id="PP" onSubmit={handlePaymentMethod}>
              <div className="inputbox">
                <input type="text" name="name" className="form-control" required />
                <span>Paypal Email Address</span>{" "}
              </div>
              <div className="pay px-5">
                <button type="submit" className="btn btn-main btn-block">
                  Add PayPal
                </button>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleTogglePP}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Button variant="" className="payment-method-selector" onClick={handleToggleMP}>
          <img
            src={process.env.REACT_APP_IMG_BASE_URL + "mercado-pago.png"}
            width="80"
            alt="MercadoPago"
          />
        </Button>
        <Modal show={showMP} onHide={handleToggleMP} backdrop="static" keyboard={false}>
          <ul className="nav nav-tabs" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <a className="nav-link">
                <img
                  src={process.env.REACT_APP_IMG_BASE_URL + "mercado-pago.png"}
                  width="80"
                  alt="MercadoPago"
                />
              </a>
            </li>
          </ul>
          <Modal.Body>
            <form className="px-5 mt-5" id="MP" onSubmit={handlePaymentMethod}>
              <div className="inputbox">
                <input type="text" name="name" className="form-control" required />
                <span>Mercado Pago Email Address</span>{" "}
              </div>
              <div className="pay px-5">
                <button type="submit" className="btn btn-main btn-block">
                  Add Mercado Pago
                </button>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleToggleMP}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <div className="col-12 mt-3">
          <div className="bg-light w- rounded border p-2 text-center">
            <i class="fa-solid fa-lock me-2 text-muted"></i>
            Select one of these payment methods to continue.
          </div>
        </div>
      </section>
    </div>
  );
}
